import { Link } from "react-router-dom";
import { styled } from "styled-components";

const BrandLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  flex: 0 0 auto;
  padding: .12rem .45rem;
  border-radius: 14px;
  background: rgba(255,255,255,.96);
  border: 1px solid rgba(255,255,255,.8);
  box-shadow: 0 8px 24px rgba(0,0,0,.14);
`;

const Logo = styled.img`
  display: block;
  width: clamp(145px, 14vw, 174px);
  height: auto;
`;

export function Brand() {
  return (
    <BrandLink to="/" aria-label="TPeck Digital home">
      <Logo src="/tpeck-logo-header.png" alt="TPeck Digital" width="885" height="355" />
    </BrandLink>
  );
}
